import { attachmentsConstants } from "../constants/attachments.constants";

const defaultState = {
	attachments: [],
	attachment: null,
	attachName: null,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case attachmentsConstants.FETCH_ATTACHMENTS + '_FULFILLED': {
			return {
				...state,
				attachments: action.payload.data.data || action.payload.data,				
				dataFetching: false,
				apiResponseError: null,
			}
		}
		case attachmentsConstants.FETCH_ATTACHMENTS + '_PENDING': {
			return {
				...state,
				dataFetching: true
			}
		}
		case attachmentsConstants.FETCH_ATTACHMENTS +'_REJECTED': {
			return {
				...state,
				dataFetching: false,
				apiResponseError: action.payload.response.status,
				apiResponseText: action.payload.response.statusText,
				apiResponseURL: action.payload.response.request.responseURL
			}
		}
		case attachmentsConstants.FETCH_ATTACHMENT + '_FULFILLED': {
			return {
				...state,
				apiResponseError: null,
				attachment: action.payload.data.data || action.payload.data,				
				attachName: action.attachName,
				dataFetching: false				
			}
		}
		case attachmentsConstants.FETCH_ATTACHMENT + '_PENDING': {
			return {
				...state,
				apiResponseError: null,
				dataFetching: true
			}
		}
		case attachmentsConstants.FETCH_ATTACHMENT +'_REJECTED': {
			return {
				...state,
				dataFetching: false,
				apiResponseError: action.payload.response.status,
				apiResponseText: action.payload.response.statusText,
				apiResponseURL: action.payload.response.request.responseURL
			}
		}
    default:
    return state;
	}
}